function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-27"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.67,
    y: 398.49,
    width: 55.23,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.81,
    y: 393.25,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.47,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.33,
    y: 397.35,
    width: 45.72,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.46,
    y: 393.12,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.72,332.09A5.71,5.71,0,0,1,237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71m-.25,0A5.47,5.47,0,0,0,237,55.2H43.91a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.16,
    y: 124.8,
    width: 66.35,
    height: 76.93,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.16,
    y: 124.8,
    width: 69.98,
    height: 76.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.55,
    y: 134.14,
    width: 65.21,
    height: 58.25,
    transform: "translate(472.42 -145.88) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.32,178H308.2a13.81,13.81,0,0,1-13.79-13.8V149.09a.56.56,0,0,1,.56-.56h15.12a13.81,13.81,0,0,1,13.8,13.8v15.12A.56.56,0,0,1,323.32,178Zm-27.79-28.35v14.55a12.69,12.69,0,0,0,12.67,12.67h14.56V162.33a12.68,12.68,0,0,0-12.67-12.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.38 153.72 359.41 153.72 366.14 97.98 428.65 97.98 435.38 153.72",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.77,
    y: 153.71,
    width: 1.22,
    height: 21.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.38,
    cy: 175.06,
    r: 1.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.71 153.72 405.65 153.72 402.88 97.98 414.93 97.98 418.71 153.72",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.6,
    y: 153.71,
    width: 7.6,
    height: 228.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.42,382.4H385.37a5.13,5.13,0,0,1,5.12-5.13H404.3a5.13,5.13,0,0,1,5.12,5.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.6,
    y: 153.71,
    width: 7.6,
    height: 4.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.58,274.33h0c-.61,0-1.22,0-1.84.06a26.14,26.14,0,0,0-23.42,32.9,131.18,131.18,0,0,1,4.1,34.07v33.46a4.38,4.38,0,0,0,4.39,4.39h72V274.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,300.48a26.16,26.16,0,1,0-51.42,6.81,131.18,131.18,0,0,1,4.1,34.07v33.46a4.38,4.38,0,0,0,4.39,4.39h33.54a4.39,4.39,0,0,0,4.39-4.39V339.4a119.36,119.36,0,0,1,4-31.93A26,26,0,0,0,470,300.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.3,
    y: 315.53,
    width: 119.26,
    height: 63.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.84,232.1h-88a17.88,17.88,0,0,0-18.1,19.79l6.7,78H384l-6.7-78A22,22,0,0,0,355.84,232.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.72,232.1h-89.9a17,17,0,0,0-17.23,18.84l6.79,79H409l-6.79-79A20.92,20.92,0,0,0,381.72,232.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.26,309.72H428.54a6.55,6.55,0,0,1,6.55,6.55V329.1a6.55,6.55,0,0,1-6.55,6.55H313.26a2,2,0,0,1-2-2v-22A2,2,0,0,1,313.26,309.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.05,274.33h0q-.92,0-1.83.06a26.17,26.17,0,0,0-23.43,32.9,130.75,130.75,0,0,1,4.1,34.07v33.46a4.39,4.39,0,0,0,4.39,4.39h72V274.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.44,300.48A26.16,26.16,0,1,0,277,307.29a130.75,130.75,0,0,1,4.1,34.07v33.46a4.39,4.39,0,0,0,4.4,4.39h33.53a4.38,4.38,0,0,0,4.39-4.39V339.4a119.37,119.37,0,0,1,4.06-31.93A26.38,26.38,0,0,0,328.44,300.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.54,382.4H248.92a3.19,3.19,0,0,1-3.19-3.19h188A3.19,3.19,0,0,1,430.54,382.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 89.83,
    width: 21.92,
    height: 292.57,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.03,
    y: 89.83,
    width: 192.37,
    height: 292.57,
    transform: "translate(328.42 472.23) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.08,
    y: 145.68,
    width: 288.26,
    height: 185.18,
    transform: "translate(402.48 74.06) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -64.76,
    y: 230.52,
    width: 288.26,
    height: 15.5,
    transform: "translate(317.64 158.9) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.03,
    y: 235.3,
    width: 4.3,
    height: 187.13,
    transform: "translate(494.05 163.68) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.03,
    y: 174.9,
    width: 4.3,
    height: 187.13,
    transform: "translate(433.65 103.28) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.03,
    y: 114.5,
    width: 4.31,
    height: 187.13,
    transform: "translate(373.25 42.88) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.03,
    y: 54.1,
    width: 4.3,
    height: 187.13,
    transform: "translate(312.85 -17.52) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.11,
    y: 104.48,
    width: 27.83,
    height: 41.03,
    transform: "translate(204.06 250) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.05,
    y: 104.48,
    width: 8.38,
    height: 41.03,
    rx: 1.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.75,
    y: 104.48,
    width: 27.83,
    height: 41.03,
    transform: "translate(185.32 250) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.69,
    y: 104.48,
    width: 8.38,
    height: 41.03,
    rx: 1.52,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.62 104.48 95.64 104.48 93.73 145.52 71.62 145.52 71.62 104.48",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.74,104.48H93.13a1.62,1.62,0,0,0-1.46,1.66l-1.76,37.72a1.47,1.47,0,0,0,1.31,1.66h5.61a1.64,1.64,0,0,0,1.46-1.66l1.76-37.72A1.46,1.46,0,0,0,98.74,104.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.82,
    y: 110.88,
    width: 21.1,
    height: 34.64,
    transform: "translate(454.74 256.39) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.97,
    y: 110.88,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.72,
    y: 110.88,
    width: 21.1,
    height: 34.64,
    transform: "translate(440.53 256.39) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.87,
    y: 110.88,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.31 110.88 222.52 110.88 221.07 145.52 204.31 145.52 204.31 110.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.87,110.88h-4.25c-.58,0-1.07.63-1.11,1.4l-1.33,31.84c0,.77.41,1.4,1,1.4h4.26c.58,0,1.07-.63,1.1-1.4l1.34-31.84C225.9,111.51,225.45,110.88,224.87,110.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.61,
    y: 110.88,
    width: 21.1,
    height: 34.64,
    transform: "translate(400.32 256.39) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.76,
    y: 110.88,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.51,
    y: 110.88,
    width: 21.1,
    height: 34.64,
    transform: "translate(386.12 256.39) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.66,
    y: 110.88,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.11 110.88 195.31 110.88 193.87 145.52 177.11 145.52 177.11 110.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.67,110.88h-4.26c-.58,0-1.07.63-1.1,1.4L191,144.12c0,.77.42,1.4,1,1.4h4.25c.58,0,1.07-.63,1.11-1.4l1.33-31.84C198.69,111.51,198.25,110.88,197.67,110.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.87,
    y: 108.28,
    width: 14.71,
    height: 37.23,
    transform: "translate(314.44 253.8) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.52,
    y: 108.28,
    width: 4.43,
    height: 37.23,
    rx: 1.05,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.61,
    y: 104.48,
    width: 16.21,
    height: 41.03,
    transform: "translate(291.43 250) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.56,
    y: 104.48,
    width: 4.88,
    height: 41.03,
    rx: 1.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.46 104.48 147.45 104.48 146.34 145.52 133.46 145.52 133.46 104.48",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26,104.48H146c-.44,0-.83.74-.85,1.66l-1,37.72c0,.91.31,1.66.76,1.66h3.27c.44,0,.82-.75.85-1.66l1-37.72C150,105.22,149.7,104.48,149.26,104.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.21,
    y: 164.88,
    width: 27.83,
    height: 41.03,
    transform: "translate(352.25 370.8) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.15,
    y: 164.88,
    width: 8.38,
    height: 41.03,
    rx: 1.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.84,
    y: 164.88,
    width: 27.83,
    height: 41.03,
    transform: "translate(333.52 370.8) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.78,
    y: 164.88,
    width: 8.38,
    height: 41.03,
    rx: 1.52,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.72 164.88 169.73 164.88 167.82 205.92 145.72 205.92 145.72 164.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,164.88h-5.61a1.62,1.62,0,0,0-1.46,1.66L164,204.26a1.46,1.46,0,0,0,1.31,1.66h5.61a1.64,1.64,0,0,0,1.46-1.66l1.75-37.72A1.45,1.45,0,0,0,172.84,164.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.87,
    y: 171.28,
    width: 17.05,
    height: 34.64,
    transform: "translate(426.79 377.19) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.54,
    y: 171.28,
    width: 5.13,
    height: 34.64,
    rx: 1.09,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.13,
    y: 171.28,
    width: 17.05,
    height: 34.64,
    transform: "translate(415.31 377.19) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.8,
    y: 171.28,
    width: 5.13,
    height: 34.64,
    rx: 1.09,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.76 171.28 209.48 171.28 208.31 205.92 194.76 205.92 194.76 171.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.38,171.28h-3.44c-.47,0-.87.63-.89,1.4L206,204.52c0,.77.33,1.4.8,1.4h3.44c.47,0,.87-.63.89-1.4l1.08-31.84C212.21,171.91,211.85,171.28,211.38,171.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.31,
    y: 177.22,
    width: 14.12,
    height: 28.69,
    transform: "translate(480.75 383.14) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.46,
    y: 177.22,
    width: 4.25,
    height: 28.69,
    rx: 0.9,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.56,
    y: 177.22,
    width: 14.12,
    height: 28.69,
    transform: "translate(471.24 383.14) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.71,
    y: 177.22,
    width: 4.25,
    height: 28.69,
    rx: 0.9,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.94 177.22 237.13 177.22 236.16 205.92 224.94 205.92 224.94 177.22",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.71,177.22h-2.85c-.39,0-.72.52-.74,1.16l-.89,26.38c0,.64.27,1.16.66,1.16h2.85c.38,0,.72-.52.74-1.16l.89-26.38C239.39,177.74,239.09,177.22,238.71,177.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.61,
    y: 171.28,
    width: 21.1,
    height: 34.64,
    transform: "translate(256.31 377.19) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.76,
    y: 171.28,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 171.28,
    width: 21.1,
    height: 34.64,
    transform: "translate(242.11 377.19) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.65,
    y: 171.28,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.1 171.28 123.31 171.28 121.86 205.92 105.1 205.92 105.1 171.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.66,171.28h-4.25a1.33,1.33,0,0,0-1.11,1.4L119,204.52c0,.77.41,1.4,1,1.4h4.25a1.33,1.33,0,0,0,1.11-1.4l1.33-31.84C126.69,171.91,126.24,171.28,125.66,171.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.02,
    y: 168.68,
    width: 14.71,
    height: 37.23,
    transform: "translate(190.75 374.6) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.67,
    y: 168.68,
    width: 4.43,
    height: 37.23,
    rx: 1.05,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.77,
    y: 164.88,
    width: 16.21,
    height: 41.03,
    transform: "translate(167.75 370.8) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 164.88,
    width: 4.88,
    height: 41.03,
    rx: 1.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.62 164.88 85.61 164.88 84.5 205.92 71.62 205.92 71.62 164.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.42,164.88H84.15c-.45,0-.83.74-.85,1.66l-1,37.72c0,.91.32,1.66.77,1.66H86.3c.45,0,.83-.75.85-1.66l1-37.72C88.2,165.62,87.86,164.88,87.42,164.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.11,
    y: 225.28,
    width: 27.83,
    height: 41.03,
    transform: "translate(204.06 491.6) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.05,
    y: 225.28,
    width: 8.38,
    height: 41.03,
    rx: 1.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.75,
    y: 225.28,
    width: 27.83,
    height: 41.03,
    transform: "translate(185.32 491.6) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.69,
    y: 225.28,
    width: 8.38,
    height: 41.03,
    rx: 1.52,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.62 225.28 95.64 225.28 93.73 266.32 71.62 266.32 71.62 225.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.74,225.28H93.13a1.62,1.62,0,0,0-1.46,1.66l-1.76,37.72a1.47,1.47,0,0,0,1.31,1.66h5.61a1.64,1.64,0,0,0,1.46-1.66l1.76-37.72A1.46,1.46,0,0,0,98.74,225.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.82,
    y: 231.68,
    width: 21.1,
    height: 34.64,
    transform: "translate(454.74 497.99) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.97,
    y: 231.68,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.72,
    y: 231.68,
    width: 21.1,
    height: 34.64,
    transform: "translate(440.53 497.99) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.87,
    y: 231.68,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.31 231.68 222.52 231.68 221.07 266.32 204.31 266.32 204.31 231.68",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.87,231.68h-4.25c-.58,0-1.07.63-1.11,1.4l-1.33,31.84c0,.77.41,1.4,1,1.4h4.26c.58,0,1.07-.63,1.1-1.4l1.34-31.84C225.9,232.31,225.45,231.68,224.87,231.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.61,
    y: 231.68,
    width: 21.1,
    height: 34.64,
    transform: "translate(400.32 497.99) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.76,
    y: 231.68,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.51,
    y: 231.68,
    width: 21.1,
    height: 34.64,
    transform: "translate(386.12 497.99) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.66,
    y: 231.68,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.11 231.68 195.31 231.68 193.87 266.32 177.11 266.32 177.11 231.68",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.67,231.68h-4.26c-.58,0-1.07.63-1.1,1.4L191,264.92c0,.77.42,1.4,1,1.4h4.25c.58,0,1.07-.63,1.11-1.4l1.33-31.84C198.69,232.31,198.25,231.68,197.67,231.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.87,
    y: 229.08,
    width: 14.71,
    height: 37.23,
    transform: "translate(314.44 495.4) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.52,
    y: 229.08,
    width: 4.43,
    height: 37.23,
    rx: 1.05,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.61,
    y: 225.28,
    width: 16.21,
    height: 41.03,
    transform: "translate(291.43 491.6) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.56,
    y: 225.28,
    width: 4.88,
    height: 41.03,
    rx: 1.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.46 225.28 147.45 225.28 146.34 266.32 133.46 266.32 133.46 225.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26,225.28H146c-.44,0-.83.74-.85,1.66l-1,37.72c0,.91.31,1.66.76,1.66h3.27c.44,0,.82-.75.85-1.66l1-37.72C150,226,149.7,225.28,149.26,225.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.19,
    y: 341.36,
    width: 17.83,
    height: 41.03,
    transform: "translate(182.2 723.76) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.52,
    y: 341.36,
    width: 5.37,
    height: 41.03,
    rx: 1.21,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.18,
    y: 341.36,
    width: 17.83,
    height: 41.03,
    transform: "translate(170.2 723.76) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.52,
    y: 341.36,
    width: 5.37,
    height: 41.03,
    rx: 1.21,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.62 341.37 87 341.37 85.78 382.4 71.62 382.4 71.62 341.37",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,341.36H85.4c-.49,0-.91.75-.94,1.66l-1.12,37.72c0,.92.35,1.66.84,1.66h3.59c.49,0,.91-.74.94-1.66L89.83,343C89.86,342.11,89.48,341.36,89,341.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.36,
    y: 347.76,
    width: 18.59,
    height: 34.64,
    transform: "translate(481.31 730.16) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.35,
    y: 347.76,
    width: 5.6,
    height: 34.64,
    rx: 1.14,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.1,
    y: 347.76,
    width: 18.59,
    height: 34.64,
    transform: "translate(468.79 730.16) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.09,
    y: 347.76,
    width: 5.6,
    height: 34.64,
    rx: 1.14,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.34 347.76 236.38 347.76 235.1 382.4 220.34 382.4 220.34 347.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46,347.76h-3.75c-.51,0-1,.63-1,1.4L232.56,381c0,.77.36,1.4.87,1.4h3.75c.51,0,.95-.63,1-1.4l1.17-31.84C239.36,348.39,239,347.76,238.46,347.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.38,
    y: 347.76,
    width: 18.59,
    height: 34.64,
    transform: "translate(433.35 730.16) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.37,
    y: 347.76,
    width: 5.6,
    height: 34.64,
    rx: 1.14,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.12,
    y: 347.76,
    width: 18.59,
    height: 34.64,
    transform: "translate(420.83 730.16) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.11,
    y: 347.76,
    width: 5.6,
    height: 34.64,
    rx: 1.14,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.36 347.76 212.4 347.76 211.13 382.4 196.36 382.4 196.36 347.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.48,347.76h-3.75c-.51,0-.95.63-1,1.4L208.58,381c0,.77.36,1.4.87,1.4h3.75c.51,0,1-.63,1-1.4l1.17-31.84C215.38,348.39,215,347.76,214.48,347.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.3,
    y: 345.17,
    width: 12.96,
    height: 37.23,
    transform: "translate(389.55 727.57) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.43,345.17h1.93a1,1,0,0,1,1,1v35.26a1,1,0,0,1-1,1h-1.93a1,1,0,0,1-1-1V346.15A1,1,0,0,1,200.43,345.17Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.5,
    y: 341.36,
    width: 14.28,
    height: 41.03,
    transform: "translate(369.28 723.76) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.78,
    y: 341.36,
    width: 4.3,
    height: 41.03,
    rx: 1.09,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.84 341.37 186.17 341.37 185.19 382.4 173.84 382.4 173.84 341.37",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.76,341.36h-2.88c-.39,0-.73.75-.75,1.66l-.9,37.72c0,.92.28,1.66.67,1.66h2.88c.39,0,.73-.74.75-1.66l.9-37.72C188.45,342.11,188.15,341.36,187.76,341.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.21,
    y: 285.68,
    width: 27.83,
    height: 41.03,
    transform: "translate(352.25 612.4) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.15,
    y: 285.68,
    width: 8.38,
    height: 41.03,
    rx: 1.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.84,
    y: 285.68,
    width: 27.83,
    height: 41.03,
    transform: "translate(333.52 612.4) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.78,
    y: 285.68,
    width: 8.38,
    height: 41.03,
    rx: 1.52,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.72 285.68 169.73 285.68 167.82 326.72 145.72 326.72 145.72 285.68",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,285.68h-5.61a1.63,1.63,0,0,0-1.46,1.66L164,325.06a1.46,1.46,0,0,0,1.31,1.66h5.61a1.64,1.64,0,0,0,1.46-1.66l1.75-37.72A1.46,1.46,0,0,0,172.84,285.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.87,
    y: 292.08,
    width: 17.05,
    height: 34.64,
    transform: "translate(426.79 618.79) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.54,
    y: 292.08,
    width: 5.13,
    height: 34.64,
    rx: 1.09,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.13,
    y: 292.08,
    width: 17.05,
    height: 34.64,
    transform: "translate(415.31 618.79) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.8,
    y: 292.08,
    width: 5.13,
    height: 34.64,
    rx: 1.09,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.76 292.08 209.48 292.08 208.31 326.72 194.76 326.72 194.76 292.08",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.38,292.08h-3.44c-.47,0-.87.63-.89,1.4L206,325.32c0,.77.33,1.4.8,1.4h3.44c.47,0,.87-.63.89-1.4l1.08-31.84C212.21,292.71,211.85,292.08,211.38,292.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.31,
    y: 298.02,
    width: 14.12,
    height: 28.69,
    transform: "translate(480.75 624.74) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.46,
    y: 298.02,
    width: 4.25,
    height: 28.69,
    rx: 0.9,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.56,
    y: 298.02,
    width: 14.12,
    height: 28.69,
    transform: "translate(471.24 624.74) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.71,
    y: 298.02,
    width: 4.25,
    height: 28.69,
    rx: 0.9,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.94 298.02 237.13 298.02 236.16 326.72 224.94 326.72 224.94 298.02",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.71,298h-2.85c-.39,0-.72.52-.74,1.16l-.89,26.38c0,.64.27,1.16.66,1.16h2.85c.38,0,.72-.52.74-1.16l.89-26.38C239.39,298.54,239.09,298,238.71,298Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.61,
    y: 292.08,
    width: 21.1,
    height: 34.64,
    transform: "translate(256.31 618.79) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.76,
    y: 292.08,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 292.08,
    width: 21.1,
    height: 34.64,
    transform: "translate(242.11 618.79) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.65,
    y: 292.08,
    width: 6.35,
    height: 34.64,
    rx: 1.21,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.1 292.08 123.31 292.08 121.86 326.72 105.1 326.72 105.1 292.08",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.66,292.08h-4.25a1.33,1.33,0,0,0-1.11,1.4L119,325.32c0,.77.41,1.4,1,1.4h4.25a1.33,1.33,0,0,0,1.11-1.4l1.33-31.84C126.69,292.71,126.24,292.08,125.66,292.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.02,
    y: 289.48,
    width: 14.71,
    height: 37.23,
    transform: "translate(190.75 616.2) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.67,
    y: 289.48,
    width: 4.43,
    height: 37.23,
    rx: 1.05,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.77,
    y: 285.68,
    width: 16.21,
    height: 41.03,
    transform: "translate(167.75 612.4) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.71,
    y: 285.68,
    width: 4.88,
    height: 41.03,
    rx: 1.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.62 285.68 85.61 285.68 84.5 326.72 71.62 326.72 71.62 285.68",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.42,285.68H84.15c-.45,0-.83.75-.85,1.66l-1,37.72c0,.91.32,1.66.77,1.66H86.3c.45,0,.83-.75.85-1.66l1-37.72C88.2,286.43,87.86,285.68,87.42,285.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.34,
    y: 338.08,
    width: 20.63,
    height: 44.32,
    transform: "translate(329.31 720.48) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.09,
    y: 338.08,
    width: 6.21,
    height: 44.32,
    rx: 1.36,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.39,
    y: 338.08,
    width: 20.63,
    height: 44.32,
    transform: "translate(315.42 720.48) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.14,
    y: 338.08,
    width: 6.21,
    height: 44.32,
    rx: 1.36,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.11 338.08 159.91 338.08 158.5 382.4 142.11 382.4 142.11 338.08",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.22,338.08h-4.16c-.57,0-1.06.8-1.09,1.79l-1.3,40.74c0,1,.4,1.79,1,1.79h4.16c.57,0,1-.8,1.08-1.79l1.3-40.74C163.22,338.88,162.78,338.08,162.22,338.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.59,
    y: 343.82,
    width: 17.83,
    height: 38.58,
    transform: "translate(265 726.22) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.92,
    y: 343.82,
    width: 5.37,
    height: 38.58,
    rx: 1.18,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.58,
    y: 343.82,
    width: 17.83,
    height: 38.58,
    transform: "translate(252.99 726.22) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 343.82,
    width: 5.37,
    height: 38.58,
    rx: 1.18,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.02 343.82 128.4 343.82 127.18 382.4 113.02 382.4 113.02 343.82",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.39,343.82H126.8c-.49,0-.91.7-.94,1.56l-1.12,35.46c0,.86.34,1.56.83,1.56h3.6c.49,0,.91-.7.93-1.56l1.13-35.46C131.26,344.52,130.88,343.82,130.39,343.82Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-27"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-27",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.13,413.62a2,2,0,0,1-2,2.62H88.83c-4.35,0-4.35-28.33,0-28.33H228.17a2,2,0,0,1,2,2.61C228.43,395.92,228.43,408.23,230.13,413.62Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.93,391.22H145.4c-3.33,0-3.33,21.71,0,21.71h84.53C228.5,407.48,228.5,396.66,229.93,391.22Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.19,413.62a2,2,0,0,1-2,2.62H88.83c-4.35,0-4.35-28.33,0-28.33h50.4a2,2,0,0,1,2,2.61C139.49,395.92,139.49,408.23,141.19,413.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.31,387.91H98.8c-4.35,0-4.35,28.33,0,28.33h11.51C106,416.24,106,387.91,110.31,387.91Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.38,387.91h-4.52c-4.35,0-4.35,28.33,0,28.33h4.52C115,416.24,115,387.91,119.38,387.91Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.71,385.56c-.48,1.16.7,2.35,2.3,2.35H208.29c5.11,0,5.11-25.47,0-25.47H83c-1.6,0-2.78,1.18-2.3,2.35C82.7,369.64,82.7,380.71,80.71,385.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.71,385.56c-.48,1.16.7,2.35,2.3,2.35h61.43c5.11,0,5.11-25.47,0-25.47H83c-1.6,0-2.78,1.18-2.3,2.35C82.7,369.64,82.7,380.71,80.71,385.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.93,365.41h61c3.91,0,3.91,19.52,0,19.52h-61C82.61,380,82.61,370.31,80.93,365.41Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.19,368.12c-.38-1.13.72-2.23,2.24-2.23H199.5c3.72,0,3.72,18.56,0,18.56H164.43c-1.52,0-2.62-1.09-2.24-2.22A28.1,28.1,0,0,0,162.19,368.12Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.73,374.19a2.33,2.33,0,0,1-2.07,3.05H266.46c-4.6,0-4.6-33,0-33h147.2a2.33,2.33,0,0,1,2.07,3C413.94,353.59,413.94,367.92,415.73,374.19Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.73,374.19a2.33,2.33,0,0,1-2.07,3.05H266.46c-4.6,0-4.6-33,0-33h147.2a2.33,2.33,0,0,1,2.07,3C413.94,353.59,413.94,367.92,415.73,374.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.53,348.12H326.22c-3.52,0-3.52,25.26,0,25.26h89.31C414,367.05,414,354.46,415.53,348.12Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.77,374.19a2.33,2.33,0,0,1-2.07,3.05H266.46c-4.6,0-4.6-33,0-33H319.7a2.33,2.33,0,0,1,2.07,3C320,353.59,320,367.92,321.77,374.19Z",
    style: {
      fill: "#2DAF8E",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.17,346.71a1.78,1.78,0,0,0-1.5-2.44h-20.3c-4.6,0-4.6,33,0,33h20.3a1.79,1.79,0,0,0,1.5-2.45C298.12,368.69,298.12,352.82,300.17,346.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.17,412.61a2.86,2.86,0,0,1-2.94,3.6l-152.94,0c-6.53,0-6.54-39,0-39l153,0a2.86,2.86,0,0,1,2.94,3.6C402.62,388.24,402.63,405.19,405.17,412.61Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.17,412.61a2.86,2.86,0,0,1-2.94,3.6l-152.94,0c-6.53,0-6.54-39,0-39l153,0a2.86,2.86,0,0,1,2.94,3.6C402.62,388.24,402.63,405.19,405.17,412.61Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.87,381.77l-92.47,0c-5,0-5,29.88,0,29.88l92.48,0C402.74,404.16,402.74,389.27,404.87,381.77Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.08,412.63a2.85,2.85,0,0,1-2.93,3.6H249.29c-6.53,0-6.54-39,0-39h53.86a2.86,2.86,0,0,1,2.94,3.6C303.54,388.26,303.54,405.2,306.08,412.63Z",
    style: {
      fill: "#2DAF8E",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.82,378.59a.9.9,0,0,0-.86-1.35h-9.15c-6.52,0-6.52,39,0,39H273a.9.9,0,0,0,.86-1.35C269.89,408.86,269.89,384.61,273.82,378.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.1,378.59a.91.91,0,0,0-.86-1.36h-9.15c-6.52,0-6.52,39,0,39h9.15a.9.9,0,0,0,.85-1.35C284.17,408.86,284.17,384.6,288.1,378.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.67,323.52a24.31,24.31,0,0,0-1.93-8.06l.9-.44a25.3,25.3,0,0,1,2,8.4Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.56,
    y: 311.13,
    width: 24.84,
    height: 1,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.51,341.54c-.51,1.36.74,2.73,2.43,2.73H397.4c5.39,0,5.39-29.64,0-29.64H237.94c-1.69,0-2.94,1.38-2.43,2.74C237.61,323,237.61,335.89,235.51,341.54Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.51,341.54c-.51,1.36.74,2.73,2.43,2.73h92c5.4,0,5.4-29.64,0-29.64h-92c-1.69,0-2.94,1.38-2.43,2.74C237.61,323,237.61,335.89,235.51,341.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.75,318.1h91.52c4.14,0,4.14,22.71,0,22.71H235.75C237.52,335.11,237.52,323.8,235.75,318.1Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.69,321.24c-.4-1.31.76-2.58,2.36-2.58h37.06c3.93,0,3.93,21.59,0,21.59H351.05c-1.6,0-2.76-1.27-2.36-2.59C350,333.51,350,325.4,348.69,321.24Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.6,98c-4.51,4.83-15.52,0-17.2,13.3-1.82,14.34,5.08,21.23-3.83,25-14,5.85-24,29.23-4.56,38s60.84-.42,56.18-18.29-3.74-27.46,1.76-35.88c7.25-11.13,5.7-25.43-.21-30.61C243.54,81.42,230.83,87,220.6,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.66,155.53a.3.3,0,0,1-.31-.27.3.3,0,0,1,.26-.35c3.86-.53,6.16-1.48,7.24-3,1.34-1.89.76-4.7,0-8.26-1.18-5.79-2.81-13.72,2.39-23.74,6.31-12.15,4-25.47-1.91-29.83a.31.31,0,0,1-.07-.43.32.32,0,0,1,.44-.07c6.16,4.51,8.54,18.19,2.09,30.62-5.09,9.82-3.49,17.63-2.33,23.33.76,3.7,1.36,6.63-.14,8.74-1.18,1.67-3.61,2.7-7.65,3.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.24,138.21a16,16,0,0,1-1.89-.12.31.31,0,0,1-.27-.35.31.31,0,0,1,.35-.27c2.84.35,4.9-.07,6.29-1.29,2.6-2.29,2.64-7.08,2.67-12.63,0-6.28.09-13.39,4.16-18.24a.31.31,0,1,1,.48.4c-3.93,4.68-4,11.67-4,17.85,0,5.69-.07,10.61-2.88,13.09A7.14,7.14,0,0,1,194.24,138.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,314.61c-6.67-.08-9.29-.5-12.36-.45s-3.8.59-7,.45c-2.16-.09-2.17-2.66-1.34-4.42.65-1.38,1.45-2.77,2.19-4.49l8.46.62c1.14,3.22,6.8,4.6,11.76,5.74C296.07,312.53,295.06,314.64,292.39,314.61Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.28,191.76s22.38,19.25,45,39.67c9.56,8.65-10.49,74.6-10.49,74.6-.42,1.41-7.88-.6-9-1.71,0,0-1.14-51.19,3.71-61.5-50.16-12.68-58-37.31-58-37.31l3.6-15.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81,211.58a53.37,53.37,0,0,0,9.89,10.48c5-5.85,3.6-15.3,3.6-15.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.53,303.18c-.14,1-.38,2.77-.51,4.08a.84.84,0,0,1-.86.76,53.66,53.66,0,0,1-9.9-1.72.75.75,0,0,1-.55-.71l-.07-3.65a.85.85,0,0,1,.93-.85l10.32,1.25A.73.73,0,0,1,284.53,303.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.53,303.18c-.14,1-.38,2.77-.51,4.08a.84.84,0,0,1-.86.76,53.66,53.66,0,0,1-9.9-1.72.75.75,0,0,1-.55-.71l-.07-3.65a.85.85,0,0,1,.93-.85l10.32,1.25A.73.73,0,0,1,284.53,303.18Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.47,362.44c-6.78,0-9-2.55-12.79-3.25-3.2-.6-4.05-.32-6.63-.77-2.16-.38-2.33-1.86-1-4.05a30.48,30.48,0,0,0,2.2-4.74l10.28.68c1.07,2.75,3.54,8.34,7.31,9C197.39,360,197.17,362.44,194.47,362.44Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,191.7s-23.65,42.05-33.17,68.06c-10,27.32-25.92,72-27.07,90.55-1.7.81-7.28.5-10.28-.68,0,0-2.78-64,16.47-89.64,4.59-54.91,12.21-63.69,20.31-70.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.73,346.52a27.08,27.08,0,0,0-.1,3.81.84.84,0,0,1-.78.89c-3.83.35-9.17-.88-10.86-1.3a.74.74,0,0,1-.56-.7l-.13-3.58a.85.85,0,0,1,.91-.86l10.84.93A.74.74,0,0,1,187.73,346.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.73,346.52a27.08,27.08,0,0,0-.1,3.81.84.84,0,0,1-.78.89c-3.83.35-9.17-.88-10.86-1.3a.74.74,0,0,1-.56-.7l-.13-3.58a.85.85,0,0,1,.91-.86l10.84.93A.74.74,0,0,1,187.73,346.52Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,150.45c1,1.89,2.08,4,3.18,6s2.21,4,3.33,5.95c2.26,3.93,4.62,7.78,7.15,11.41l-1.36-1.21a11.93,11.93,0,0,0,3.28,1.62,28.1,28.1,0,0,0,4.34,1.08c1.54.28,3.14.47,4.77.62s3.34.24,4.9.34h.21a2.8,2.8,0,0,1,.73,5.45,38.11,38.11,0,0,1-5.47,1.38,41.59,41.59,0,0,1-5.64.61,30.62,30.62,0,0,1-6-.36,19.89,19.89,0,0,1-6.4-2.12,3.83,3.83,0,0,1-1.09-.89l-.27-.32c-1.59-1.9-3.14-3.84-4.56-5.83s-2.81-4-4.1-6-2.54-4.13-3.72-6.24-2.3-4.2-3.37-6.51a5.6,5.6,0,0,1,10-5Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,142.38c6.53,2.15,7.59,5.08,11.17,15.9-2.38,6.49-12,9.78-12,9.78S235.29,149.56,247.48,142.38Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42,156.46c-.37,3.58-1.29,7.85-3.22,16.24-1.5,7.12-1.52,21-3.92,21.73-4.61,2.28-16.15,1.4-36.29-4.82.64-10.4,1.85-17.46-1.61-41.32a8.54,8.54,0,0,1,8.7-10c1.46,0,3,.12,4.57.26a115.49,115.49,0,0,1,16.48,2.19c1.77.4,3.6.87,5.34,1.35A13.78,13.78,0,0,1,256.42,156.46Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.92,197.82l2-1.83a3.15,3.15,0,0,0,1-2.72l-.55-4.77a5.94,5.94,0,0,0-3-4.52l-1-.57c-3.57,2.81-5.36,8.47-5.36,8.47l-.69,1.56a2.64,2.64,0,0,0,1.27,3.54l3.07,1.4A3.05,3.05,0,0,0,185.92,197.82Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.89,173.8l-2.56-1a3.16,3.16,0,0,0-2.89.34l-4,2.68a5.91,5.91,0,0,0-2.61,4.77l0,1.19c4.13,1.88,10,.86,10,.86l1.7-.1a2.65,2.65,0,0,0,2.56-2.76l-.16-3.37A3,3,0,0,0,290.89,173.8Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.34,151.51l-1.28.59-1.4.64c-.93.45-1.85.92-2.77,1.4-1.85,1-3.65,2-5.42,3.05s-3.48,2.22-5.14,3.41-3.2,2.49-4.7,3.82l.66-.84a15.91,15.91,0,0,0-1.28,2.26c-.44.91-.85,1.9-1.25,2.91-.8,2-1.58,4.14-2.3,6.29s-1.45,4.33-2.16,6.51l-2.16,6.57v0a2.8,2.8,0,0,1-5.46-1c.11-2.41.33-4.75.6-7.11s.61-4.71,1-7.07.9-4.73,1.55-7.13c.32-1.2.67-2.4,1.11-3.66a23,23,0,0,1,1.78-4,4.25,4.25,0,0,1,.43-.59l.24-.25a56.48,56.48,0,0,1,5.28-5.11,63.49,63.49,0,0,1,5.78-4.37,66.36,66.36,0,0,1,6.15-3.7c1.06-.56,2.13-1.09,3.22-1.61.55-.25,1.09-.51,1.66-.75s1.09-.45,1.8-.72a5.59,5.59,0,0,1,4.32,10.31Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,140.89c-4.9-3.51-7.88-3.89-19.74,1.26-1.41,7.46,3.21,18.41,3.21,18.41S226.25,152.34,227,140.89Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.28,120.11c.73,5.49,1.2,15.44-2.72,18.52,0,0,5.12-.09,14.91,7.92,3.67-4,1.57-5.73,1.57-5.73-5.83-2.21-5.42-6.62-4.15-10.65Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,144.93c-3.57,0-5.38,5.19-5.38,5.19s-8.58-6.84-9.75-11.65a36,36,0,0,0,3.34-1.55S236.62,142.63,238.4,144.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.82,144.8s2.7,1,3.59,5c1.83-7.62-1.74-8.82-1.74-8.82a4.5,4.5,0,0,0-3.12-.88A3.79,3.79,0,0,1,241.82,144.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,124.21l5.68,6a16.44,16.44,0,0,0-.67,2.88c-2.24-.63-5.2-3.54-5.3-6A7.9,7.9,0,0,1,232.2,124.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.12,112.12c2,8.54,2.73,12.19,7.86,16.09,7.71,5.86,17.72,2.06,18.26-6.78.48-8-2.94-20.6-12-23A11.26,11.26,0,0,0,222.12,112.12Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.79,118.26c3.14-1.54,6.47-9.11,2-12.69,3.69.69,7.92-.3,11.83-3.32,5.1-4,12.61,5.93,10.14.1-3.56-8.4-14.29-10.5-24-3.52S214.74,114.3,223.79,118.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.13,116.55a.16.16,0,0,1-.06-.3c2.5-1.08,13.11-3.34,13.56-3.43a.15.15,0,0,1,.19.12.16.16,0,0,1-.12.18c-.11,0-11,2.35-13.51,3.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,113a4.44,4.44,0,0,0-3.38-.08A8.76,8.76,0,0,0,234,113Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,113.76a3.66,3.66,0,0,0-3,.69A7.38,7.38,0,0,0,233.91,113.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,112.88c.14.73.63,1.27,1.1,1.21s.73-.69.59-1.42-.64-1.26-1.1-1.21S235.72,112.16,235.86,112.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.64,111.93c.14.72.64,1.26,1.1,1.21s.73-.7.59-1.42-.63-1.27-1.1-1.21S244.5,111.2,244.64,111.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,110.58l1.62-.72S246,111.33,245,110.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,113.32a21.9,21.9,0,0,0,3.18,4.51,3,3,0,0,1-2.49.65Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.85,121.71a7.13,7.13,0,0,0,1.21,0,.2.2,0,0,0,.17-.24.23.23,0,0,0-.25-.19,6.15,6.15,0,0,1-5-1.67.21.21,0,0,0-.3,0,.22.22,0,0,0,0,.3A6.43,6.43,0,0,0,239.85,121.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.09,119.77a6.06,6.06,0,0,0,4.17,2.53c2.08.17,2.53-2.25,1.47-4.4-.95-1.93-3.18-4.36-5-3.52S218.74,118,220.09,119.77Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,107.37a.37.37,0,0,0,.29-.14,3.17,3.17,0,0,1,2.74-1.21.4.4,0,0,0,.46-.36.48.48,0,0,0-.39-.49,4,4,0,0,0-3.48,1.49.45.45,0,0,0,.38.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.26,107a.4.4,0,0,0,.3-.09.42.42,0,0,0,0-.6,4.51,4.51,0,0,0-3.62-1.7.39.39,0,0,0-.35.47.46.46,0,0,0,.48.39,3.59,3.59,0,0,1,2.86,1.37A.43.43,0,0,0,246.26,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.57,117.41c-2.11,0-3.94-2.24-4.14-5.11a6.4,6.4,0,0,1,.89-3.87,3.54,3.54,0,0,1,2.71-1.79c2.21-.15,4.15,2.14,4.36,5.11s-1.42,5.5-3.61,5.65ZM238.24,107h-.18a3.27,3.27,0,0,0-2.48,1.65,6.07,6.07,0,0,0-.84,3.68c.19,2.79,2,4.94,4,4.81s3.51-2.53,3.32-5.32S240.19,107,238.24,107Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.92,116.87c-2.11,0-3.95-2.23-4.15-5.1a6.47,6.47,0,0,1,.89-3.87,3.56,3.56,0,0,1,2.72-1.79c2.19-.15,4.15,2.14,4.35,5.1a6.47,6.47,0,0,1-.89,3.87,3.54,3.54,0,0,1-2.72,1.79Zm-.33-10.45h-.19a3.27,3.27,0,0,0-2.48,1.65,6.21,6.21,0,0,0-.84,3.68c.19,2.7,1.89,4.81,3.84,4.81h.18a3.24,3.24,0,0,0,2.48-1.65,6.12,6.12,0,0,0,.84-3.67C251.23,108.53,249.53,106.42,247.59,106.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,112.18a.16.16,0,0,1-.13-.08c-.38-.6-1.49.05-1.5.05a.15.15,0,0,1-.21-.05.16.16,0,0,1,0-.21c.06,0,1.38-.82,1.92,0a.14.14,0,0,1-.05.21A.11.11,0,0,1,244,112.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.25,111.53l1.61-.71S237.25,112.29,236.25,111.53Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.db67846bc04b295191db48ba46cee462.svg";
export { ForwardRef as ReactComponent };